import { type ApiRoleStrategy, ROLES } from "@pharmupp/p3-front-commons"

export const adminBasePath = "/api/news/lab-post"
export const apiRoleConf: ApiRoleStrategy = {
  [ROLES.ADMIN]: {
    endpoint: adminBasePath,
    queryKey: ["news", "extraLabNewsFlashs", "list"],
  },
}
